// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__RGpK5","feedback":"TextInput_feedback__mkEF3","infoPrompt":"TextInput_infoPrompt__QW0vj","inputPassword":"TextInput_inputPassword__xdQjE"};